/**
 * Ionicons stub for web platform
 * Re-exports the HTML-based Ionicons implementation
 */
import { Ionicons } from './htmlIconStubs';
export default Ionicons;
